// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiTooltip } from "@mdi/js";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import { selectShowTooltip } from "../../context/xdaSettingsSelectors";

function XdaTooltipToggle() {
  const showTooltip = useXdaSettingsStore(selectShowTooltip);
  const updateXdaSettings = useXdaSettingsStore((s) => s.updateXdaSettings);

  const handleToggle = (active: boolean) => {
    updateXdaSettings({ showTooltip: active });
  };

  return (
    <ToolbarButton
      icon={<Icon path={mdiTooltip} size={1.5} />}
      active={showTooltip}
      tooltipText={"Show Tooltip"}
      overflowLabel={"Tooltip"}
      onToggle={handleToggle}
      styleKey="xdaToolbar"
    />
  );
}

export default XdaTooltipToggle;
